import { Button, Card } from '@repo/shadcn';
import { Link } from 'react-router-dom';

import { SectionContainer } from '@components/shared';
import { HeaderBreadcrumb } from '@components/ui';
import PageHeading from '@components/ui/heading/page-headeing.tsx';

import { Route } from '@/constants';
import { PurchaseTableFilters } from '@/modules/purchase/purchase-list/purchase-table-filter.component';
import { PurchaseTable } from '@/modules/purchase/purchase-list/purchase-table.component.tsx';

import {
    PurchaseListProvider,
    usePurchaseListContext,
} from './purchase-list.context.tsx';

const PurchaseListComponent = () => {
    const { isLoading, isError, error } = usePurchaseListContext();

    return (
        <SectionContainer
            error={error}
            fallbackPath={Route.DASHBOARD}
            isError={isError}
            isLoading={isLoading}
        >
            <Card className={'space-y-4 p-4'}>
                <div className={'flex items-start justify-between pb-4'}>
                    <div className={'space-y-4'}>
                        <HeaderBreadcrumb items={[{ label: 'Purchases' }]} />
                        <PageHeading
                            title={'Purchases'}
                            subTitle={'View and manage all purchases'}
                        />
                    </div>
                    <div>
                        <Link to={Route.PRE_PURCHASE_CREATE}>
                            <Button type={'button'}>Create Purchase</Button>
                        </Link>
                    </div>
                </div>

                <PurchaseTableFilters />
                <PurchaseTable />
            </Card>
        </SectionContainer>
    );
};

export const PurchaseList = () => {
    return (
        <PurchaseListProvider>
            <PurchaseListComponent />
        </PurchaseListProvider>
    );
};

PurchaseList.displayName = 'PurchaseList';
